export const CACHE_KEYS = {
  ACTIVITY_MASTER_LIST: "ACTIVITY_MASTER_LIST",
  CITY_MASTER_LIST: "CITY_MASTER_LIST",
  AREA_MASTER_LIST: "AREA_MASTER_LIST",
  WHAT_WE_DO_MASTER_LIST: "WHAT_WE_DO_MASTER_LIST",
  SUPPORT_TICKETS_LIST: "SUPPORT_TICKETS_LIST",
  SUPPORT_TICKET_COUNTS: "SUPPORT_TICKET_COUNTS",
  VENDOR_OVERVIEW: "VENDOR_OVERVIEW",
};

export const RENEWAL_STATUS = {
  on_schedule: "Active",
  retrying: "Retrying",
  grace_period: "Grace Period",
  cancelled: "Cancelled",
  failed: "Failed",
};

export const RENEWAL_STATUS_COLOR = {
  Active: "green",
  Cancelled: "red",
  "Grace Period": "orange",
  Retrying: "yellow",
  Failed: "red",
};

export const MEMBERSHIP_STATUS = {
  pending:   "Pending",
  active:    "Active",
  expired:   "Expired",
  cancelled: "Cancelled",
  failed:    "Failed",
};

export const MEMBERSHIP_STATUS_COLOR = {
  Pending:   "default",
  Active:    "green",
  Expired:   "orange",
  Cancelled: "red",
  Failed:    "red",
};


export const ACCOUNT_TYPES = {
  COMMUNITY_LEAD: "COMMUNITY_LEAD",
  WORKSHOP_ORGANISER: "WORKSHOP_ORGANISER",
};

/** Session-only draft after signup, read on /application-status */
export const PARTNER_ONBOARDING_DRAFT_KEY = "partner-onboarding-draft";

/**
 * Ant Design Tag color map for account / vendor verification status.
 * Values: PENDING | VERIFIED | REJECTED
 */
export const VERIFICATION_STATUS_COLOR = {
  PENDING:  "warning",
  VERIFIED: "success",
  REJECTED: "error",
};

/**
 * Ant Design Tag color map for booking status.
 * Values: CONFIRMED | ATTENDED | CANCELLED | NO_SHOW | PENDING
 * Used across both the Events (AttendeesTab) and Orders (BookingsTab) features.
 */
export const BOOKING_STATUS_COLOR = {
  CONFIRMED: "success",
  ATTENDED:  "success",
  CANCELLED: "error",
  NO_SHOW:   "warning",
  PENDING:   "warning",
};
